import type { GetterTree } from "vuex";

import type {
  DataAnalyticsState,
  RootState,
  Variable,
  Scenario,
  DataAnalyticsConfig,
} from "@/types";

export const getters: GetterTree<DataAnalyticsState, RootState> = {
  // VARIABLES
  getVariablesData(state): Variable[] {
    return state.variables.data;
  },
  getVariablesCount(state): number {
    return state.variables.count;
  },
  getVariablesLoading(state): boolean {
    return state.variables.loading;
  },
  getVariablesError(state): string | null {
    return state.variables.error;
  },
  getModelizationLoading(state): boolean {
    return state.modelization.loading;
  },
  getCurrentModelizationVariable(state): any {
    return state.modelization.data.variableToModel;
  },
  getCurrentVariablesExplicatives(state): any {
    return state.modelization.data.variablesExplicatives;
  },
  getCurrentModelingResult(state): any {
    return state.modelization.data.ModelingResult;
  },
  getCurrentModelingResultData(state): any {
    return state.modelization.data.modelingResultData;
  },
  getModelizationProcessStatus(state): string | null {
    return state.modelization.progress;
  },
  getModelizationError(state): any {
    return state.modelization.error;
  },
  getNewScenario(state): Scenario {
    return state.newScenario.data;
  },
  getNewScenarioLoading(state): boolean {
    return state.newScenario.loading;
  },
  getNewScenarioError(state): string | null {
    return state.newScenario.error;
  },
  getDataAnalyticsConfigLoading(state): boolean {
    return state.dataAnalyticsConfig.loading;
  },
  getDataAnalyticsConfigData(state): DataAnalyticsConfig[] {
    return state.dataAnalyticsConfig.data;
  },
  getDataAnalyticsError(state): string | null {
    return state.dataAnalyticsConfig.error;
  },
};
